export const MessagePage = ({ message }: { message: string }) => {
  return <div className='h-full flex items-center justify-center bg-stone-900 text-white text-3xl'>{message}</div>
}
